module.exports = __webpack_public_path__ + "static/itsm_capabilities_3_1-3cd604b9f2043bb41acbdc4e79776101.png";